import { useMemo } from 'react'
import { preFixImgUrl } from '@/utils'

export type BenefitCard = {
  img: string
  titleKey: string
  descKey: string
}

export type HowToScreen = {
  img: string
  titleKey: string
}

export type QuickLinkItem =
  | { key: string; iconImg: string; to: string }
  | { key: string; iconImg: string; href: string; openInNewTab?: boolean }

const BENEFIT_ILL_FILES = [
  '8359b5b1bf41eb26542bd1b836a276b7.png',
  'bc8c1eb9dc6e70318703b81a6fce1b28.png',
  'e2b347132a8379a14e5f420be5847190.png',
  '5a8d24e24037aa2df2f563d604569773.png',
] as const

const BENEFIT_TITLE_KEYS = ['318650ee', 'be004f13', 'c33ce7f5', '4b9ebb9c'] as const
const BENEFIT_DESC_KEYS = ['49b76537', '2ff42cdc', 'd2e27565', 'dca1ec53'] as const

/** 使用步骤手机截图（与线上一致，可替换） */
const HOWTO_IMG_FILES = [
  '210699842e12567f03122f89be15dd78.png',
  '2bb191c8db68703df4acfc464a9f198a.png',
  'ae8ff2ac7402ec20fbba892c6e94a2d9.png',
  '713c76ae98307c3875b3fef3391a7cab.png',
] as const

const HOWTO_TITLE_KEYS = ['498f0c35', '5f0b58af', '69fd2eb1', '9eac6ba3'] as const

/** 快捷入口：用户条款 /items，注意事项、常见问题独立页，联系我们 mailto */
const SAGAWA_QUICK_LINKS = [
  { key: '00a5d8ee', iconFile: 'e62cca86d301cb431507da5775a49803.png', to: '/items' },
  {
    key: '487853f3',
    iconFile: '604ce17e39d715e03b02aba7b3874804.png',
    href: 'https://file.bilionpass.com/sagawa_luggage_service_customer_web_revised.html',
    openInNewTab: true,
  },
  { key: '2aefc7a2', iconFile: '05e814b0f7beb684207c85db7417ec8d.png', to: '/airport-luggage-faq' },
  { key: '2c7782ea', iconFile: '691e96c40a4369e0f941c4b9fdf709da.png', href: 'mailto:bilionpass@jdxjp.net' },
] as const

export default function useModel() {
  const benefitCards = useMemo<BenefitCard[]>(
    () =>
      BENEFIT_ILL_FILES.map((file, i) => ({
        img: preFixImgUrl(file),
        titleKey: BENEFIT_TITLE_KEYS[i],
        descKey: BENEFIT_DESC_KEYS[i],
      })),
    [],
  )

  const howToScreens = useMemo<HowToScreen[]>(
    () =>
      HOWTO_IMG_FILES.map((file, i) => ({
        img: preFixImgUrl(file),
        titleKey: HOWTO_TITLE_KEYS[i],
      })),
    [],
  )

  const quickLinks = useMemo<QuickLinkItem[]>(
    () =>
      SAGAWA_QUICK_LINKS.map((row) => {
        const base = { key: row.key, iconImg: preFixImgUrl(row.iconFile) }
        if ('href' in row) {
          return {
            ...base,
            href: row.href,
            ...('openInNewTab' in row && row.openInNewTab ? { openInNewTab: true } : {}),
          }
        }
        return { ...base, to: row.to }
      }),
    [],
  )

  return { benefitCards, howToScreens, quickLinks }
}
